import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

import { api, setAccessToken } from '@/lib/api';
import { errorMessage } from '@/lib/errorMessage';
import { useAuth } from '@/providers/AuthProvider';

/**
 * Запуск демо-сессии (F-25).
 *
 * Общий для страницы входа и лендинга: кнопка «Посмотреть демо» должна
 * открывать демо сразу, а не вести на форму входа. Отправлять человека
 * ещё куда-то ради обещанного одним кликом — верный способ его потерять.
 */
export function useDemoSession(onError?: (message: string) => void) {
  const { t } = useTranslation(['auth', 'errors']);
  const { refreshMe } = useAuth();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: () =>
      api.post<{ accessToken: string; username: string; expiresAt: string }>(
        '/auth/demo',
        undefined,
        { skipWorkspace: true, skipRefresh: true },
      ),
    onSuccess: async (result) => {
      // Сессию поднимаем теми же средствами, что и обычный вход: отдельная
      // ветка авторизации для демо однажды разошлась бы с основной.
      setAccessToken(result.accessToken);
      await refreshMe();
      navigate('/', { replace: true });
    },
    onError: (error) => {
      const message = errorMessage(error, t);
      if (onError) onError(message);
      else toast.error(message);
    },
  });
}
